import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import DronePartDetails from "../components/droneParts/DronePartDetails";
import SingularProduct from "../components/droneParts/SingularProduct";
import { Header, Footer } from "../shared";

const DronePartDetailsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <DronePartDetails />
      <SingularProduct />
      <Footer />
    </div>
  );
};

export default DronePartDetailsPage;
